import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
			logoAlignment: 'left',
			logoColor: 'primary',
		}),

		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'See how fast you can hit your weight loss goals with Carnivore Diet',
			size: 'small',
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: require('@/data/lottie-animations/sphereAnimation.json'),
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 4000,
		}),
	},
}

export default schema
